import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ContentBox from '../../components/ContentBox';
import StaffCalendar from '../../components/staff/StaffCalendar';
import StaffLogFeed from '../../components/staff/StaffLogFeed';
import { visibleStaffNav } from '../../components/staff/staffNav';

function StaffHome({ userData }) {
    const nav = useMemo(() => visibleStaffNav(userData), [userData]);

    const toSection = (item) => (
        item.groups
            ? { ...item, groups: item.groups.filter(group => !group.admin) }
            : { ...item, groups: [{ links: [{ path: item.path, label: 'Events Calendar' }] }] }
    );

    const sections = useMemo(
        () => nav
            .filter(item => !['home', 'admin', 'moderation', 'frankopop'].includes(item.key))
            .map(toSection)
            .filter(item => item.groups.length > 0),
        [nav]
    );

    const sidebarSections = useMemo(
        () => ['frankopop', 'moderation']
            .map(key => nav.find(item => item.key === key))
            .filter(Boolean)
            .map(toSection)
            .filter(item => item.groups.length > 0),
        [nav]
    );

    const renderSection = (section, options = {}) => (
        <ContentBox
            key={section.key}
            theme="default"
            tint={section.tint || 'lightskyblue'}
            header={section.label}
            className={options.flush ? '!mb-0' : ''}
        >
            <div className="flex flex-col gap-3">
                {section.groups.map((group, groupIndex) => (
                    <div key={groupIndex} className="flex flex-col gap-2">
                        {group.header && (
                            <span className="font-['Jersey_10'] text-[16px] uppercase tracking-[1px] text-maroon">
                                {group.header}
                            </span>
                        )}
                        {group.links.map(link => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className="rounded bg-gray-200 px-3 py-2 font-['Jersey_10'] text-[16px] uppercase tracking-[1px] text-gray-800 transition-all hover:bg-gray-300"
                                style={{ boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)' }}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                ))}
            </div>
        </ContentBox>
    );

    return (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
            <div className="xl:col-span-2">
                <ContentBox theme="default" tint="red" header={`Welcome, ${userData?.habboName || 'staff'}`}>
                    <p className="text-gray-700">
                        Everything staff-side now lives here. Pick a tool from the bar above, or jump straight in below.
                    </p>
                </ContentBox>

                <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2">
                    {sections.map(section => renderSection(section, { flush: true }))}
                </div>

                <StaffLogFeed userData={userData} />
            </div>

            <div className="xl:col-span-1">
                <StaffCalendar userData={userData} />
                {sidebarSections.map(section => renderSection(section))}
            </div>
        </div>
    );
}

export default StaffHome;
